export enum LEARNING_EVENTS {
    /**
     * @value This page provides access to all learning events created.
     */
    EMPTY_STATE_HELPER = 'LEARNING_EVENTS.EMPTY_STATE_HELPER',
    /**
     * @value No learning events yet
     */
    NO_EVENTS_YET = 'LEARNING_EVENTS.NO_EVENTS_YET',
    /**
     * @value {"one":"%NUMBER% event out of many","other":"%NUMBER% events out of many"}
     */
    NUMBER_EVENTS_OUT_OF_MANY = 'LEARNING_EVENTS.NUMBER_EVENTS_OUT_OF_MANY',
    /**
     * @value Pick a space
     */
    PICK_SPACE = 'LEARNING.PICK_SPACE',
    /**
     * @value Pick a training course
     */
    PICK_TRAINING = 'LEARNING.PICK_TRAINING',
    /**
     * @value Related training course
     */
    RELATED_TRAINING = 'LEARNING.RELATED_TRAINING',
    /**
     * @value Schedule a learning event
     */
    SCHEDULE_EVENT = 'LEARNING.SCHEDULE_EVENT',
    /**
     * @value Select the Space that will host this event. Please be aware that all users with access to this Space will be able to view the event.
     */
    SELECT_SPACE_TO_HOST_EVENT = 'LEARNING.SELECT_SPACE_TO_HOST_EVENT',
    /**
     * @value Select a training course
     */
    SELECT_TRAINING = 'LEARNING.SELECT_TRAINING',
    /**
     * @value Select the training course associated with this event.
     */
    SELECT_TRAINING_ASSOCIATED_TO_EVENT = 'LEARNING.SELECT_TRAINING_ASSOCIATED_TO_EVENT',
    /**
     * @value Space host
     */
    SPACE_HOST = 'LEARNING.SPACE_HOST',
    /**
     * @value Learning events
     */
    TITLE = 'LEARNING_EVENTS.TITLE',
}
